import { render } from "./Myorder.vue?vue&type=template&id=224a2a77&scoped=true"
import script from "./Myorder.vue?vue&type=script&lang=js"
export * from "./Myorder.vue?vue&type=script&lang=js"

import "./Myorder.vue?vue&type=style&index=0&id=224a2a77&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224a2a77"]])

export default __exports__